import { render, staticRenderFns } from "./AvatarOffset.vue?vue&type=template&id=518308ae&"
import script from "./AvatarOffset.vue?vue&type=script&lang=js&"
export * from "./AvatarOffset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports